import Row from "react-bootstrap/esm/Row";
import ToggleButtonGroup from "react-bootstrap/ToggleButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";
import "../main.css";
import { useState } from "react";

function ChooseNumOfNums({ tftInfo, setTftInfo }) {
  const TIRE_PLY_STMT = "Choose Tire Construction...";
  const [curClickedButton, setCurClickedButton] = useState({
    twoNums: "",
    threeNums: "",
  });

  const handleClick = (event) => {
    if (event === "threeNums") {
      setCurClickedButton({ twoNums: "", threeNums: "clicked" });
      setTftInfo({
        notation: "metric",
        msrmtNames: {
          one: { short: "tireWidth", long: "1st Number" },
          two: { short: "aspectRatio", long: "2nd Number" },
          three: { short: "rimDia", long: "3rd Number" },
        },
        initValues: {
          measurements: {
            firstNum: "",
            middleNum: "",
            lastNum: "",
          },
          construction: TIRE_PLY_STMT,
          notation: "metric",
        },
      });
    } else if (event === "twoNums") {
      setCurClickedButton({ twoNums: "clicked", threeNums: "" });
      setTftInfo({
        notation: "stdTwoNums",
        msrmtNames: {
          two: { short: "tireWidth", long: "Tire Width (in.)" },
          three: { short: "rimDia", long: "3rd Number" },
        },
        initValues: {
          measurements: {
            firstNum: "",
            lastNum: "",
          },
          construction: TIRE_PLY_STMT,
          notation: "stdTwoNums",
        },
      });
    }
  };

  return (
    <div className={tftInfo === null ? "py-5 my-5" : ""}>
      <Row
        className={
          tftInfo === null
            ? `justify-content-center mt-5`
            : `justify-content-center`
        }
      >
        <h2 className="pb-2 text-center">
          {tftInfo === null
            ? "Choose the Amount of Numbers Your Tire Size Contains"
            : "Rim Guard's Tire Fill Tool"}
        </h2>
      </Row>
      <Row className="pb-3 justify-content-center">
        <ToggleButtonGroup
          type="radio"
          name="chooseNumNums"
          onChange={handleClick}
        >
          <ToggleButton
            value="twoNums"
            id="twoNums"
            className={`${curClickedButton.twoNums} shadow-none btn-rg-purple-outlined-left`}
          >
            Two Numbers
          </ToggleButton>
          <ToggleButton
            value="threeNums"
            id="threeNums"
            className={`${curClickedButton.threeNums} shadow-none btn-rg-purple-outlined-right`}
          >
            Three Numbers
          </ToggleButton>
        </ToggleButtonGroup>
      </Row>
    </div>
  );
}

export default ChooseNumOfNums;
